import { Image, Flex } from "@chakra-ui/react";

export default function Logo({
  justify = "flex-start",
  mb = "36px",
  width = "80%",
}: {
  justify?: string;
  mb?: string;
  width?: string;
}) {
  return (
    <Flex justifyContent={justify} w={width} mb={mb}>
      <Image src="/logo.png" />
    </Flex>
  );
}
